if (!customElements.get('cart-toggle')) {
    class CartToggle extends HTMLElement {
        static observedAttributes = ["count"];

        constructor() {
            super();

            this.elToggle = this.querySelector('[data-cart-toggle]');
            this.elCount = this.querySelector('[data-count]');

            this.elToggle && this.elToggle.addEventListener('click', (ev) => {
                ev.preventDefault();
                window.toggleCart();
            });
        }

        attributeChangedCallback(name, oldValue, newValue) {
            this.elCount.innerHTML = newValue;
            this.elCount.classList.toggle('has-items', Number(newValue) > 0);
        }
    }

    customElements.define('cart-toggle', CartToggle);
}